export const EMPIRE_CODE = "Empire Code:";
export const PRODUCT_NAME = "Product Name:";
export const PRODUCT_DESCRIPTION = "Product Description:";
export const DESCRIPTION = "Description";
export const SHORT_DESCRIPTION = "Short Description:";
export const COMMERCIAL_DESCRIPTION = "Commercial Description";
export const MORE_INFORMATION = "More Information";
export const CT_PORTFOLIO = "CT Portfolio:";
export const PRODUCT_RESOURCES = "PRODUCT RESOURCES";
export const PRODUCT_RESOURCES_LIMIT = 25;

export const GLOBAL_SERVICE_CODE = "PRODUCT GLOBAL SERVICE CODE";
export const GLOBAL_SERVICE_CODE_PRIMARY_LIST =
  "Global Service Code Primary List:";
export const GLOBAL_SERVICE_CODE_SECONDARY_LIST =
  "Global Service Code Secondary List:";
export const PRODUCT_CONTACTS = "Product Contacts";
export const COMMERCIAL_OWNER_NAME = "Commercial Owner Name:";
export const COMMERCIAL_OWNER_PROXY_NAME = "Commercial Owner Proxy Name:";
export const PRODUCT_OWNER_NAME = "Product Owner Name";
export const CT_PRODUCT_MANAGER = "CT Technical Product Manager:";
export const SUPPORT = "Support";
export const ORDER_ACKNOWLEDGEMENT = "Order acknowledgment";
export const GLOBAL_RISK_MANAGER = "Global Risk Manager";
export const GLOBAL_RISK_MANAGER_FIELD = "global_risk_manager";
export const LOCAL_RISK_MANAGER = "Local Risk Manager";
export const PRODUCT_APPROVER = "Product Approver";
export const PROVISIONING_TEAM = "Provisioning Team";
export const DEMAND_MANAGEMENT_TEAM_ID = "Demand Management Teams ID:";
export const TEAM_EMAIL_ID = "Team Email ID:";
export const SUPPORT_LINK = "Support Link:";
export const SUPPORT_LINK_NAME = "Name to appear in Commercial Hub";
export const SKUS = "SKUs";
export const CREATE_NEW_SKUS = "Create New SKUS";
export const SAVE_DRAFT = "Save Draft";
export const NEXT = "Next";
export const PRIMARY_LIST_PLACEHOLDER = "Primary List";
export const SECONDARY_LIST_PLACEHOLDER = "Secondary List";
export const EMAIL_ID_PLACEHOLDER = "Email ID";
export const PRODUCT_SUPPORT_LINK = "Enter URL";
export const PRODUCT_CONTACT_PLACEHOLDER = "Product Contact";
export const EMPIRE_CODE_PLACEHOLDER = "Empire Code (required)";
export const PRODUCT_COST_SETUP = "Product Cost Setup";
export const PRODUCT_DETAILS_LABEL = "Product Details";
export const DOWNLOAD_API_KEYS = "Download API Keys";
export const DEMAND_MANAGEMENT_TEAM_ID_LABEL =
  "CT Demand Management support group | General | Microsoft Teams";
export const DEMAND_MANAGEMENT_TEAM_ID_URL =
  "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fchannel%2F19%3A749l0Wc1ulYbzkITs19wktovOBkRpIaJIeQgk21pNaM1%40thread.tacv2%2FGeneral%3FgroupId%3D68d8f316-4338-4e6b-95eb-eb1366bd0058%26tenantId%3D5b973f99-77df-4beb-b27d-aa0c70b8482c&type=channel&deeplinkId=b2244765-8ee9-4d7d-980e-ab0d3d50e1e3&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true";
export const BMO_LABEL = "Business Management Office Approvals ";
export const BMO_DESCRIPTION =
  "The BMO Team manages SKU governance, product costs, and billing types. Their main goal is to ensure all product SKUs are accurately reviewed, all cost rates are correctly calculated, and billing types are assigned in line with enterprise policies and compliance requirements.";
